export const initialCadastreErrorFormStore = {
  errorForm1: [], errorForm2: [], errorForm3: [], errorForm6: [],
};
const initialCadastreStore = { ...initialCadastreErrorFormStore };

export default initialCadastreStore;
